import { render } from "./DevicesGrid.vue?vue&type=template&id=8b8df1b2&scoped=true"
import script from "./DevicesGrid.vue?vue&type=script&lang=js"
export * from "./DevicesGrid.vue?vue&type=script&lang=js"

import "./DevicesGrid.vue?vue&type=style&index=0&id=8b8df1b2&lang=scss&scoped=true"
import "./DevicesGrid.vue?vue&type=style&index=1&id=8b8df1b2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8df1b2"]])

export default __exports__